export default __webpack_public_path__ + "static/media/title-2-right.7e2e736a.svg";